import { NOTIFICATION_TYPE } from '../../../../constants/common'
import i18n from '../../../../i18n'
import { DocFlowSendingWidgetNotificationType } from '../../DocFlowSending'

import {
  DOC_FLOW_SENDING_RESULT_ERROR_NOTIFICATION_ID,
  DOC_FLOW_SENDING_RESULT_PERMANENT_NOTIFICATION_ID,
  DOC_FLOW_SENDING_RESULT_SUCCESS_NOTIFICATION_ID,
} from './DocFlowSendingResultWidget.constants'

export function getDocFlowSendingResultPermanentNotifications() {
  return [
    {
      id: DOC_FLOW_SENDING_RESULT_PERMANENT_NOTIFICATION_ID,
      text: i18n.t('DocumentStapling.SendingPhaseResultWidgetNotificationKey'),
      type: NOTIFICATION_TYPE.info,
    },
  ]
}

export function getDocFlowSendingResultWidgetNotifications(t) {
  return {
    [DocFlowSendingWidgetNotificationType.Error]: {
      id: DOC_FLOW_SENDING_RESULT_ERROR_NOTIFICATION_ID,
      text: t('DocumentStapling.SendingPhaseResultWidgetErrorNotificationKey'),
      type: NOTIFICATION_TYPE.error,
    },
    [DocFlowSendingWidgetNotificationType.Success]: {
      id: DOC_FLOW_SENDING_RESULT_SUCCESS_NOTIFICATION_ID,
      text: t(
        'DocumentStapling.SendingPhaseResultWidgetSuccessNotificationKey'
      ),
      type: NOTIFICATION_TYPE.success,
    },
  }
}
